<template>
  <div>
    <p style="text-align: center">
      <span class="systemFont0">{{ $t("p0413.specialOffer") }}</span>
    </p>
    <el-col :span="22" :offset="1">
      <el-tabs
        style="min-width: 1000px;user-select: none"
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane :label="$t('p0413.limitedTime')" name="first">
          <p0414 ref="p0414"></p0414>
        </el-tab-pane>
        <el-tab-pane :label="$t('p0413.specifyPerson')" name="second">
          <p0415 ref="p0415"></p0415>
        </el-tab-pane>
      </el-tabs>
    </el-col>
  </div>
</template>

<script>
import p0414 from "../../Marketing/CouponCode/P0414";
import p0415 from "../../Marketing/CouponCode/P0415";
export default {
  components: {
    p0414,
    p0415
  },
  data() {
    return {
      // 绿夹克上课名称列表
      classNameList: [],
      // 绿夹克上课编号
      classNumList: [],
      // 限时优惠form
      limitDouponCodeForm: {},
      // 活跃的标签
      activeName: "first"
    };
  },
  methods: {
    // 选择的标签
    handleClick(tab, event) {
      console.log(tab, event);
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.main {
  width: 90%;
  margin: 0 auto;
  padding-top: 17px;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/views/Marketing/CouponCode/P0413.vue